"use strict";

export default function pick(object, keys) {
  return keys.reduce(function (obj, key) {
    if (typeof object[key] !== 'undefined') {
      obj[key] = object[key];
    }

    return obj;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-leaflet/es/utils/pick.js
// module id = 1110
// module chunks = 0